import React from 'react';
type StatCardProps = {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  change?: {
    value: string;
    positive: boolean;
  };
  description?: string;
};
export function StatCard({
  title,
  value,
  icon,
  change,
  description
}: StatCardProps) {
  return <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200" data-id="element-521">
      <div className="flex items-center" data-id="element-522">
        <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center mr-4" data-id="element-523">
          {icon}
        </div>
        <div data-id="element-524">
          <p className="text-sm font-medium text-gray-500" data-id="element-525">{title}</p>
          <h3 className="text-2xl font-bold text-gray-900 mt-1" data-id="element-526">{value}</h3>
          {change && <div className="flex items-center mt-1" data-id="element-527">
              <span className={`text-xs font-medium ${change.positive ? 'text-green-600' : 'text-red-600'}`} data-id="element-528">
                {change.positive ? '↑' : '↓'} {change.value}
              </span>
              <span className="text-xs text-gray-500 ml-1" data-id="element-529">vs last month</span>
            </div>}
        </div>
      </div>
      {description && <p className="mt-4 text-sm text-gray-600" data-id="element-530">{description}</p>}
    </div>;
}